export const MAX_QUEUED_TOASTS = 5;
const listeners = new Set();
let nextToastId = 1;
let notifications = [];
const emitChange = () => {
    listeners.forEach((listener) => listener());
};
export const getToastSnapshot = () => notifications;
export const subscribeToToasts = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
export const enqueueToast = (type, message) => {
    const notification = {
        id: `toast-${nextToastId}`,
        message,
        type,
    };
    nextToastId += 1;
    notifications = [...notifications, notification].slice(-MAX_QUEUED_TOASTS);
    emitChange();
    return notification;
};
export const dismissToast = (id) => {
    const nextNotifications = notifications.filter((notification) => notification.id !== id);
    if (nextNotifications.length === notifications.length) {
        return;
    }
    notifications = nextNotifications;
    emitChange();
};
export const clearToastQueue = () => {
    if (notifications.length === 0) {
        return;
    }
    notifications = [];
    emitChange();
};
//# sourceMappingURL=toast-store.js.map